import React, {Fragment} from "react";
import {Box} from "@mui/system";
import Checkbox from "@mui/material/Checkbox/Checkbox";
import {useTheme} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery/useMediaQuery";
import businessLogo from "components/images/business.svg"
import styles from "../../styles/Providers.module.css"

export default function PageRow({ page, pageId, key, value, label, input, disabled, disabledText }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const addDefaultSrc = (ev) => {
    ev.target.src = businessLogo
  };

  return(
    <Fragment>
      <Box className={styles.pageRowContainer} key={key} {...input}>
        <Box className={styles.pageInfoContainer}>
          <Box className={styles.imageContainer}>
            <img onError={addDefaultSrc} src={"http://graph.facebook.com/" + pageId + "/picture?type=square"} className={styles.thumbnail} alt="page thumbnail"/>
          </Box>
          <Box className={isMobile ? styles.pageNameMobile : styles.pageName}>
            <span className={disabled ? styles.disabledColor : ""}>{label}</span>
            <span className={styles.disabledText}>{disabledText}</span>
          </Box>
        </Box>
        <Box className={styles.checkboxContainer}>
          <Checkbox
            value={value}
            disabled={disabled}
            sx={disabled ?
              {'& .MuiSvgIcon-root': {fontSize: '25px', color: '#c5c5c5'}} :
              {'& .MuiSvgIcon-root': {fontSize: '25px', color: '#003300'}}} />
        </Box>
      </Box>
    </Fragment>
  )
}